import * as Sentry from "@sentry/react";
import { sentryBeforeSendInterceptor } from "./interceptors";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    sendDefaultPii: true,
    beforeSend(event, hint) {
      if (sentryBeforeSendInterceptor(event, hint)) {
        return null;
      }

      return event;
    },
  });
}
